var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.useV2 && _vm.siteKeyV2)?_c('VueRecaptcha',{ref:"captcha",staticClass:"recaptcha",attrs:{"sitekey":_vm.siteKeyV2,"load-recaptcha-script":true},on:{"verify":_vm.executeV2,"expired":_vm.expired}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }